/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getSims = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Sim query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-sim/get?${queryString}`);
};

export const getSimByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-sim/${id}`);
};

export const getSimByNumber = (number) => {
  return API.get(`${getApiUrl()}/api/tkt1-sim/number/${number}`);
};

export const createSim = (simData) => {
  return API.post(`${getApiUrl()}/api/tkt1-sim/`, simData);
};

export const updateSim = (id, simData) => {
  return API.put(`${getApiUrl()}/api/tkt1-sim/${id}`, simData);
};

export const updateSimByNumber = (number, simData) => {
  return API.put(`${getApiUrl()}/api/tkt1-sim/number/${number}`, simData);
};

export const deleteSim = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-sim/${id}`);
};

export const tkt1SimService = {
  getSims,
  getSimByID,
  getSimByNumber,
  createSim,
  updateSim,
  updateSimByNumber,
  deleteSim
};